import React, { useContext } from "react";
import LanguageContext from "../../../../utils/Contexts/LanguageContext";
import moment from "moment";

import "./style.css";

const PlacementCheck = ({ isValidPlacement, checked }) => {
  const { t } = useContext(LanguageContext);
  
  return (
    <>
      <div className="card">
        <div
          className="d-flex justify-content-between align-items-center"
          style={{
            cursor: "pointer",
            background:
              isValidPlacement === null
                ? "var(--bs-card-border-color)"
                : isValidPlacement === true
                ? "#01c9a5"
                : "#ed4c78",
            padding: "7px 21px",
            borderRadius: "10px 10px 0px 0px",
            height: "54px",
          }}
        >
          <li className="list-inline-item d-inline-flex gap-2">
            <h3 style={{ fontSize: "16px", fontWeight: "700" }} className="m-0">
              {isValidPlacement === null
                ? t("Pending Placement Check")
                : isValidPlacement === true
                ? t("Placement Verified")
                : t("Placement Verification Failed")}
            </h3>
          </li>
          {isValidPlacement !== null && checked !== null && (
            <span style={{ float: "right !important", color: "white" }}>
              {t("Checked")}{" "}
              {moment.utc(checked).diff(moment.utc(), "years") < -1
                ? moment.utc(checked).format("MMM D, YYYY")
                : Math.abs(moment.utc(checked).diff(moment.utc(), "days")) === 1
                ? `1 ${t("day ago")}`
                : Math.abs(moment.utc(checked).diff(moment.utc(), "days")) > 1
                ? `${Math.abs(moment.utc(checked).diff(moment.utc(), "days"))} ${t("day")}s`
                : Math.abs(moment.utc(checked).diff(moment.utc(), "hours")) >= 1
                ? `${Math.abs(moment.utc(checked).diff(moment.utc(), "hours"))}${t("h")}`
                : Math.abs(moment.utc(checked).diff(moment.utc(), "minutes")) >= 1
                ? `${Math.abs(moment.utc(checked).diff(moment.utc(), "minutes"))}${t("m")}`
                : `${Math.abs(moment.utc(checked).diff(moment.utc(), "seconds"))}${t("s")}`}
            </span>
          )}
        </div>
        <div className="placement_check_text">
          {isValidPlacement === null
            ? t(
                "Before finalizing the Contract, we must conduct a series of validations to ensure the page is avaible, crawlable, and indexable. Additionally, we need to confirm that the required links and the anchor texts apear on the pagewith the correct link relation attributes as specified in the Contract."
              )
            : isValidPlacement === true
            ? t(
                "Placement under the contract has been confirmed. You may now proceed with finalizing the contract."
              )
            : t(
                "One or more placement verification checks have failed. For additional details, please review the Placement verification section or follow the Learn More links."
              )}
        </div>
      </div>
    </>
  );
};

export default PlacementCheck;
